var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignLeft03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99998 21V3M2.99998 17.9986H19.3842C19.9505 17.9986 20.2337 17.9986 20.4501 17.8896C20.6403 17.7937 20.795 17.6407 20.892 17.4526C21.0022 17.2387 21.0022 16.9586 21.0022 16.3986V15.3559C21.0022 14.7959 21.0022 14.5159 20.892 14.302C20.795 14.1138 20.6403 13.9608 20.4501 13.8649C20.2337 13.7559 19.9505 13.7559 19.3842 13.7559L2.99999 13.7559M2.99997 10.2386L15.539 10.2386C16.1054 10.2386 16.3886 10.2386 16.6049 10.1296C16.7952 10.0337 16.9499 9.88073 17.0468 9.69257C17.1571 9.47866 17.1571 9.19863 17.1571 8.63858L17.1571 7.59594C17.1571 7.03589 17.1571 6.75586 17.0468 6.54195C16.9499 6.35379 16.7952 6.20081 16.6049 6.10494C16.3886 5.99594 16.1054 5.99594 15.539 5.99594L2.99998 5.99594",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeft03);
export default __webpack_public_path__ + "static/media/align-left-03.7b908644db7faf3c971adcab7285ea28.svg";
export { ForwardRef as ReactComponent };